import { Component, Input, OnInit } from '@angular/core';
import { InputWrapperComponent } from "../input-wrapper/input-wrapper.component";

@Component({
  selector: 'psc-range',
  styleUrls: ['range.component.scss'],
  templateUrl: './range.component.html',
})
export class RangeComponent extends InputWrapperComponent<number> implements OnInit{

  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;
  @Input() stepLabels: string[] = [];
  /**
   * In style after:border-t-sun-yellow
   **/
  @Input() tooltipArrowColorClass = 'after:border-t-sun-yellow';
  /**
   * In style accent-blue1
   **/
  @Input() sliderColorClass = 'accent-blue2';

  override ngOnInit() {
    super.ngOnInit();
    if (this.stepLabels.length === 0) {
      for (let i = this.min; i <= this.max; i += (this.max - this.min) / 4) {
        this.stepLabels.push(i.toString());
      }
    }
    const halfValuePoint = (this.max - this.min) / 2;
    this.writeValue(halfValuePoint - (halfValuePoint % this.step));
  }

  calculateLeft() {
    const val: number = ((this.value - this.min) * 100) / (this.max - this.min);
    return `calc(${ val }% + (${ 8 - val * 0.15 }px))`;
  }
}
